import React from 'react';

interface ReleaseNoteTitleProps {
  title: string;
  date: string;
}

const ReleaseNoteTitle = ({ title, date }: ReleaseNoteTitleProps) => {
  const d = new Date(date);

  return (
    <div>
      {title}
      <div className="release_note__date">{d.toLocaleDateString()}</div>
    </div>
  );
};

export default ReleaseNoteTitle;
